
//邮箱正则 该字符类仅包括大小写字母和数字。使用连字符、下划线和点号作为特殊字符，并支持匹配 IP 地址和域名两种格式的电子邮件地址
export const EMAIL_REGEXP = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//手机号正则
export const MOBILE_REGEXP = /^1[3456789]\d{9}$/;